
import React from 'react';
import { Container, Col, Row } from 'react-grid-system';

import Navigation from '../molecules/Navigation';

import ErrorBoundary from '../organisms/ErrorBoundary';

/**
 * Standard Page Template puts `children` into a formatted Row component.
 * 
 * @param children Components to populate this Page component with
 * @returns 
 */
const StandardPageTemplate = ({ children = null }: { children: any }): JSX.Element => {
  return (
    <ErrorBoundary>
      <Navigation />
      <Container>
        <Row align="center" style={{
          minHeight: 'calc(100vh - 105px)',
          paddingBottom: '52.5px',
        }}>
          <Col sm={12}>
            { children }
          </Col>
        </Row>
      </Container>
    </ErrorBoundary>
  );
};

export default StandardPageTemplate;
